export default "__VITE_ASSET__BE2fE2ct__"